import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "id_category" }
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = { for: "type" }
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "price" }
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = { for: "discount" }
const _hoisted_27 = { class: "form-group col-12 col-md-6" }
const _hoisted_28 = { for: "description" }
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = { for: "image" }
const _hoisted_31 = { class: "form-group col-12 col-md-6" }
const _hoisted_32 = { for: "is_highlight" }
const _hoisted_33 = { class: "form-group col-12 col-md-6" }
const _hoisted_34 = { for: "image_highlight" }
const _hoisted_35 = { class: "form-group col-12 col-md-6" }
const _hoisted_36 = { for: "platform_video_name" }
const _hoisted_37 = { class: "form-group col-12 col-md-6" }
const _hoisted_38 = { for: "video_display_name" }
const _hoisted_39 = { class: "form-group col-12 col-md-6" }
const _hoisted_40 = { for: "enabled" }
const _hoisted_41 = { class: "form-group col-12 col-md-6" }
const _hoisted_42 = { for: "isFree" }
const _hoisted_43 = { class: "card-footer text-center" }
const _hoisted_44 = { class: "btn-group" }
const _hoisted_45 = { class: "card card-success card-outline" }
const _hoisted_46 = { class: "card-header" }
const _hoisted_47 = { class: "card-title" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }, null, -1)
const _hoisted_49 = { class: "card-tools" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "card-body row body-table-list" }
const _hoisted_53 = {
  class: "table-list",
  style: {"width":"-webkit-fill-available"},
  cellpadding: "3"
}
const _hoisted_54 = { style: {"max-width":"60px"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"60px"} }, null, -1)
const _hoisted_56 = { style: {"text-align":"center"} }
const _hoisted_57 = { style: {"text-align":"center"} }
const _hoisted_58 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_59 = { class: "btn-group" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { class: "card card-success card-outline" }
const _hoisted_70 = { class: "card-header" }
const _hoisted_71 = { class: "card-title" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }, null, -1)
const _hoisted_73 = { class: "card-tools" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "card-body row body-table-list" }
const _hoisted_77 = {
  class: "table-list",
  style: {"width":"-webkit-fill-available"},
  cellpadding: "3"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"60px"} }, null, -1)
const _hoisted_79 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_80 = { class: "btn-group" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_88 = { class: "modal-dialog" }
const _hoisted_89 = { class: "modal-content bg-danger" }
const _hoisted_90 = { class: "modal-header" }
const _hoisted_91 = { class: "modal-title" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = { class: "modal-body" }
const _hoisted_95 = { class: "modal-footer justify-content-between" }
const _hoisted_96 = {
  key: 1,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_97 = { class: "modal-dialog modal-lg" }
const _hoisted_98 = { class: "modal-content" }
const _hoisted_99 = { class: "modal-header" }
const _hoisted_100 = { class: "modal-title" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "modal-body" }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "form-group col-12" }
const _hoisted_106 = { for: "idProduct" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_108 = { class: "form-group col-12 col-md-6" }
const _hoisted_109 = { for: "lang" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "pt" }, "PT", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "EN", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("option", { value: "es" }, "ES", -1)
const _hoisted_114 = [
  _hoisted_111,
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = { class: "form-group col-12 col-md-6" }
const _hoisted_116 = { for: "name" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_118 = { class: "form-group col-12" }
const _hoisted_119 = { for: "description" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ", -1)
const _hoisted_121 = { class: "modal-footer justify-content-between" }
const _hoisted_122 = {
  key: 2,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_123 = { class: "modal-dialog" }
const _hoisted_124 = { class: "modal-content bg-danger" }
const _hoisted_125 = { class: "modal-header" }
const _hoisted_126 = { class: "modal-title" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = { class: "modal-body" }
const _hoisted_130 = { class: "modal-footer justify-content-between" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.product")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.product")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.page.product")) + " | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.entity.category")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.category ? _ctx.row.category.description : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("labels.entity.type")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.type ? _ctx.row.type : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("labels.entity.price")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.row.price)), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("labels.entity.discount")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.formatNumber(_ctx.row.discount)), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("labels.entity.description")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.description), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("labels.entity.image")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.image ? _ctx.row.image : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("labels.entity.is_highlight")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.is_highlight,
            'bg-danger': !_ctx.row.is_highlight
          }])
              }, _toDisplayString(_ctx.row.is_highlight ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("labels.entity.image_highlight")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.image_highlight ? _ctx.row.image_highlight : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("labels.entity.platform_video_name")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.platform_video_name ? _ctx.row.platform_video_name : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("labels.entity.video_display_name")) + ":    ", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.row.video_display_name ? _ctx.row.video_display_name : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("labels.entity.active")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.enabled,
            'bg-danger': !_ctx.row.enabled
          }])
              }, _toDisplayString(_ctx.row.enabled ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("labels.entity.isFree")) + ":    ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
            'bg-success': _ctx.row.isFree,
            'bg-danger': !_ctx.row.isFree
          }])
              }, _toDisplayString(_ctx.row.isFree ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "editButton",
                    class: "btn btn-sm btn-warning",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.edit()))
                  }, _toDisplayString(_ctx.$t("labels.buttons.edit")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h3", _hoisted_47, [
              _hoisted_48,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.page.platform")), 1)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-xs btn-block btn-primary",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.newPlatform())),
                style: {"width":"33px"},
                "data-tooltip": "Novo"
              }, _hoisted_51)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("table", _hoisted_53, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.code_video_external")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.url")), 1),
                _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
                _hoisted_55
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.platforms, (i, k) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.id,
                  class: "table-grid"
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.name), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(i.code_video_external), 1),
                  _createElementVNode("td", null, _toDisplayString(i.url), 1),
                  _createElementVNode("td", _hoisted_57, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
                'bg-success': i.enabled,
                'bg-danger': !i.enabled
              }])
                    }, _toDisplayString(i.enabled ? _ctx.$t("labels.yes") : _ctx.$t("labels.no")), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("a", {
                          onClick: $event => (_ctx.viewPlatform(i.id)),
                          class: "btn btn-xs btn-success",
                          title: "Editar"
                        }, _hoisted_62, 8, _hoisted_60),
                        _createElementVNode("a", {
                          onClick: $event => (_ctx.editPlatform(i.id)),
                          class: "btn btn-xs btn-warning",
                          title: "Editar"
                        }, _hoisted_65, 8, _hoisted_63),
                        _createElementVNode("a", {
                          onClick: $event => (_ctx.deletePlatform(i.id, i.name)),
                          class: "btn btn-xs btn-danger",
                          title: "Remover"
                        }, _hoisted_68, 8, _hoisted_66)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("h3", _hoisted_71, [
              _hoisted_72,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.page.translations")), 1)
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-xs btn-block btn-primary",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.newProductLanguage())),
                style: {"width":"33px"},
                "data-tooltip": "Novo"
              }, _hoisted_75)
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("table", _hoisted_77, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.lang")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("labels.entity.description")), 1),
                _hoisted_78
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.row.languages, (i, k) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.id,
                  class: "table-grid"
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.name), 1),
                  _createElementVNode("td", null, _toDisplayString(i.lang), 1),
                  _createElementVNode("td", null, _toDisplayString(i.description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("a", {
                          onClick: $event => (_ctx.editProductLanguage(i.id)),
                          class: "btn btn-xs btn-warning",
                          title: "Editar"
                        }, _hoisted_83, 8, _hoisted_81),
                        _createElementVNode("a", {
                          onClick: $event => (_ctx.deleteProductLanguage(i.id, i.name)),
                          class: "btn btn-xs btn-danger",
                          title: "Remover"
                        }, _hoisted_86, 8, _hoisted_84)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      (_ctx.showDeletePlatform)
        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("h4", _hoisted_91, _toDisplayString(_ctx.$t("labels.page.removePlatform")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "$t('labels.buttons.close')",
                    onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_93)
                ]),
                _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.msgDeletePlatform), 1),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.close")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.deletePlatformConfirm && _ctx.deletePlatformConfirm(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.confirm")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showInsertProductLanguage || _ctx.showEditProductLanguage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("h4", _hoisted_100, _toDisplayString(_ctx.$t("labels.page.translations")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Fechar",
                    onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_102)
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("label", _hoisted_106, [
                        _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.product")) + " ", 1),
                        _hoisted_107
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.row.video_display_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("label", _hoisted_109, [
                        _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.lang")) + " ", 1),
                        _hoisted_110
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        id: "lang",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.rowProductLanguage.lang) = $event)),
                        style: {"width":"auto","max-width":"-webkit-fill-available"},
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.lang }])
                      }, _hoisted_114, 2), [
                        [_vModelSelect, _ctx.rowProductLanguage.lang]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.lang), 513), [
                        [_vShow, _ctx.errors.lang != null]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("label", _hoisted_116, [
                        _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.name")) + " ", 1),
                        _hoisted_117
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        id: "name",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.rowProductLanguage.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                        maxlength: "200"
                      }, null, 2), [
                        [_vModelText, _ctx.rowProductLanguage.name]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.name), 513), [
                        [_vShow, _ctx.errors.name != null]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("label", _hoisted_119, [
                        _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.description")) + " ", 1),
                        _hoisted_120
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "description",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.rowProductLanguage.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }])
                      }, null, 2), [
                        [_vModelText, _ctx.rowProductLanguage.description]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                        [_vShow, _ctx.errors.description != null]
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
                    [_vShow, _ctx.errorMessage != '']
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-default",
                    onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.goBack")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary",
                    onClick: _cache[13] || (_cache[13] = $event => (_ctx.saveProductLanguage(_ctx.showInsertProductLanguage)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.save")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteProductLanguage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("h4", _hoisted_126, _toDisplayString(_ctx.$t("labels.page.removeProductLanguage")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "$t('labels.buttons.close')",
                    onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _hoisted_128)
                ]),
                _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.msgDeleteProductLanguage), 1),
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.close")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-light",
                    onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.deleteProductLanguageConfirm && _ctx.deleteProductLanguageConfirm(...args)))
                  }, _toDisplayString(_ctx.$t("labels.buttons.confirm")), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}